export const SET_DIALOG = "set_dialog"
export const CLEAR_DIALOG = "clear_dialog"